/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Trash_TitleInputs */

const cs_documents_trash_title = /** @type {(inputs: Documents_Trash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koš`)
};

const en_documents_trash_title = /** @type {(inputs: Documents_Trash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trash`)
};

/**
* | output |
* | --- |
* | "Trash" |
*
* @param {Documents_Trash_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_trash_title = /** @type {((inputs?: Documents_Trash_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Trash_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_trash_title(inputs)
	return cs_documents_trash_title(inputs)
});